import type { Components, Theme } from '@mui/material/styles';

// Шкала радиусов по дизайн-макету двухуровневая: контролы ВВОДА — `borderM`
// (8px), крупные поверхности (карточки, меню, модалки) — `borderL` (16px).
// Поля жили на 16px и читались «пилюлями» рядом с таблицей реестра, у которой
// радиус 8px. Кнопки в макете остаются скруглёнными — `button.ts` не трогаем.

const MuiInputBase: Components<Theme>['MuiInputBase'] = {
  styleOverrides: {
    /**
     * Корневые стили инпута
     * @param root0 Пропсы инпута
     * @param root0.theme Тема
     */
    root: ({ theme }) => ({
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      borderRadius: theme.shape.borderM,
      backgroundColor: theme.palette.common.white
    })
  }
};

const MuiOutlinedInput: Components<Theme>['MuiOutlinedInput'] = {
  styleOverrides: {
    /**
     * Корневые стили ипута варианта outlined
     * @param root0 Пропсы инпута
     * @param root0.theme Тема
     */
    root: ({ theme }) => ({
      borderRadius: theme.shape.borderM,
      '& > fieldset > legend': {
        fontSize: `0.825rem`
      }
    }),
    /**
     * Стили placeholder
     * @param root0 Пропсы инпута
     * @param root0.theme Тема
     */
    input: ({ theme }) => ({
      '&::placeholder': {
        color: theme.palette.text.secondary,
        opacity: 1
      }
    })
  }
};

const MuiFilledInput: Components<Theme>['MuiFilledInput'] = {
  styleOverrides: {
    /**
     * Корневые стили ипута варианта filled
     * @param root0 Пропсы инпута
     * @param root0.theme Тема
     */
    root: ({ theme }) => ({
      borderRadius: 0,
      borderTopLeftRadius: theme.shape.borderM,
      borderTopRightRadius: theme.shape.borderM
    })
  }
};

export const textfield = {
  MuiInputBase,
  MuiOutlinedInput,
  MuiFilledInput
};
